import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function IceMakerSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("iceMaker.title")}</title>
        <meta name="keywords" content={t("iceMaker.keywords")} />
        <meta name="description" content={t("iceMaker.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1e2a38]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/ice-maker-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_14%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#121c28]/92 via-[#121c28]/72 to-[#121c28]/62" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("iceMaker.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("iceMaker.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("iceMaker.knowledgeBase.rootLabel")}
        rootColor="#0891b2"
        treeTranslationKey="iceMaker.knowledgeBase.tree"
        i18nPrefix="iceMaker.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="iceMaker"
        images={{
          painPoints: "/solutions/ice-maker-pain.jpeg",
          solutions: "/solutions/ice-maker-solutions.jpeg",
          cta: "/solutions/ice-maker-pain.jpeg",
        }}
        imagesPos={{
          painPoints: "50% 24%",
          solutions: "53% 28%",
          cta: "50% 12%",
        }}
      />
    </>
  );
}
